import { setThemeColors } from "@/services";

export default {
  created() {
    this.$nextTick(() => {
      setThemeColors({
        'main-bar-color': this.$route.query['main-bar-color'],
        'tab-bar-color': this.$route.query['tab-bar-color'],
        'button-color': this.$route.query['button-color'],
        'block-head-color': this.$route.query['block-head-color'],
        'table-head-color': this.$route.query['table-head-color'],
        'list-head-color': this.$route.query['list-head-color'],
        'link-color': this.$route.query['link-color'],
        'text-black-color': this.$route.query['text-black-color'],
        'text-grey-color': this.$route.query['text-grey-color'],
        'text-light-grey-color': this.$route.query['text-light-grey-color'],
      });
    });
  }
};
